// extracted by mini-css-extract-plugin
export const pagination = "Pagination-module--pagination--3KtNE";
export const pagination__prev = "Pagination-module--pagination__prev--zMktG";
export const pagination__prevLink = "Pagination-module--pagination__prev-link--3jAZB";
export const pagination__prevLinkDisable = "Pagination-module--pagination__prev-link--disable--EGYQZ";
export const pagination__next = "Pagination-module--pagination__next--pQWkh";
export const pagination__nextLink = "Pagination-module--pagination__next-link--nnhVc";
export const pagination__nextLinkDisable = "Pagination-module--pagination__next-link--disable--2G3jh";